import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#707070",
    viewBox: "0 0 80 80",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="40" cy="40" r="38" stroke="inherit" stroke-width="inherit"/> <path stroke="inherit" stroke-width="2" d="M33.39 26.991a4.067 4.067 0 11-8.134 0 4.067 4.067 0 018.134 0zm22.278 0a4.067 4.067 0 11-8.134 0 4.067 4.067 0 018.134 0zM37.24 42.675v14.506H21.417V41.676a6.129 6.129 0 016.13-6.13h3.551a6.128 6.128 0 016.129 6.13v1h.013zm22.278 0v14.506H43.695V41.676a6.13 6.13 0 016.13-6.13h3.551a6.128 6.128 0 016.129 6.13v1h.013z"/> <path stroke="#fff" stroke-width="6" d="M29 51l22-22M29 29l22 22"/> <path stroke="inherit" stroke-width="3" d="M30 50l20-20M30 30l20 20"/>' }
  })
);